var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{staticClass:"footer"},[_c('span',[_vm._v("© 2024 Pitch English. All Rights Reserved")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }